import { computed, ref } from '@vue/composition-api'

export function useOtpTimer({ startSeconds = 30, onResend }) {
  const timerActive = ref(false)
  const timerSeconds = ref(startSeconds)
  let timerInterval = null

  const formattedTimer = computed(() => {
    const minutes = Math.floor(timerSeconds.value / 60)
    const seconds = timerSeconds.value % 60
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  })

  function startTimer() {
    clearTimer()
    timerSeconds.value = startSeconds
    timerActive.value = true
    timerInterval = setInterval(() => {
      if (timerSeconds.value > 0) {
        timerSeconds.value -= 1
      } else {
        clearTimer()
      }
    }, 1000)
  }

  function clearTimer() {
    if (timerInterval) clearInterval(timerInterval)
    timerActive.value = false
    timerInterval = null
  }

  async function resendCode() {
    if (typeof onResend === 'function') {
      await onResend()
    }
    startTimer()
  }

  return {
    timerActive,
    formattedTimer,
    startTimer,
    clearTimer,
    resendCode,
  }
}
